import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowsRepeat: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowsRepeat"><Path fillRule="evenodd" clipRule="evenodd" d="M12.6271 0.689453L16.8326 4.74995L12.6271 8.81045L11.5852 7.73134L13.8963 5.49995H4.5V14H3V3.99995H13.8963L11.5852 1.76856L12.6271 0.689453ZM21 9.99995V20H10.1037L12.4148 22.2313L11.3729 23.3104L7.16738 19.25L11.3729 15.1895L12.4148 16.2686L10.1037 18.5H19.5V9.99995H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowsRepeat;
